export const REFRESH_BANNER_HEIGHT = 36;
